import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  DocumentReferenceEntityType,
  entityName,
  PersonDocumentReference,
} from '@qtek/shared/models';
import { DocumentReferenceService } from '../core/document-reference.service';

@Injectable({ providedIn: 'root' })
export class PersonDocumentReferenceService extends DocumentReferenceService<PersonDocumentReference> {
  protected http = inject(HttpClient);
  protected entityName: entityName = 'PersonDocumentReference';
  readonly entityType = DocumentReferenceEntityType.PERSON;
}
